import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import { ClientPortalAuthProvider } from './context/ClientPortalAuthContext';
import { ToastProvider } from './components/Toast';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import ClientPortalProtectedRoute from './components/ClientPortalProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Contrats from './pages/Contrats';
import Clients from './pages/Clients';
import Licenses from './pages/Licenses';
import CnrcDesktopLicenses from './pages/CnrcDesktopLicenses';
import DesktopVersions from './pages/DesktopVersions';
import Ddns from './pages/Ddns';
import Creances from './pages/Creances';
import ExpiredContrats from './pages/ExpiredContrats';
import Admin from './pages/Admin';
import SupportTickets from './pages/SupportTickets';
import SupportChat from './pages/SupportChat';
import ClientPortalLogin from './pages/client/ClientPortalLogin';
import ClientPortalLayout from './pages/client/ClientPortalLayout';
import ClientPortalProfile from './pages/client/ClientPortalProfile';
import ClientPortalTickets from './pages/client/ClientPortalTickets';
import ClientPortalChat from './pages/client/ClientPortalChat';
import './styles/theme.css';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <ClientPortalAuthProvider>
            <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/client/login" element={<ClientPortalLogin />} />
            <Route
              path="/client"
              element={
                <ClientPortalProtectedRoute>
                  <ClientPortalLayout />
                </ClientPortalProtectedRoute>
              }
            >
              <Route index element={<Navigate to="profile" replace />} />
              <Route path="profile" element={<ClientPortalProfile />} />
              <Route path="tickets" element={<ClientPortalTickets />} />
              <Route path="chat" element={<ClientPortalChat />} />
            </Route>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Contrats />} />
              <Route path="clients" element={<Clients />} />
              <Route path="licenses" element={<Licenses />} />
              <Route path="cnrc-desktop-licenses" element={<CnrcDesktopLicenses />} />
              <Route path="versions" element={
                <ProtectedRoute requiredPermission={{ entity: 'desktop_versions', action: 'view' }}>
                  <DesktopVersions />
                </ProtectedRoute>
              } />
              <Route path="acces-distant" element={
                <ProtectedRoute requiredPermission={{ entity: 'ddns', action: 'view' }}>
                  <Ddns />
                </ProtectedRoute>
              } />
              <Route path="creances" element={
                <ProtectedRoute requiredPermission={{ entity: 'creances', action: 'view' }}>
                  <Creances />
                </ProtectedRoute>
              } />
              <Route path="expired" element={<ExpiredContrats />} />
              <Route path="support" element={<SupportTickets />} />
              <Route path="support-chat" element={<SupportChat />} />
              <Route path="admin" element={
                <ProtectedRoute requiredPermission={{ entity: 'admin', action: 'access' }}>
                  <Admin />
                </ProtectedRoute>
              } />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </BrowserRouter>
            </ClientPortalAuthProvider>
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
